<template>
  <main class="main main--has-floating-buttons">

    <card :key="new Date().getMinutes()" title="Support Informationen" cols="12 6@desktop" rows="2">
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <span class="info-text info-text--full-size info-text--no-margin col-12">Bitte überprüfe ob deine Ihre Frage in unserer <a href="https://docs.hotelmeister.io/" target="_blank">Dokumentation</a> bereits beantwortet wurde, bevor du unseren Support kontaktierst.</span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner title="Wichtige Links">
        <span class="link--support col-12"><a href="https://docs.hotelmeister.io/" target="_blank">Dokumentation / Knowledge Base</a></span>
        <span class="link--support col-12"><a href="https://www.youtube.com/channel/UCWLVUfImCcLOL-G7cMXOITQ" target="_blank">YouTube-Kanal</a></span>
        <span class="link--support col-12"><a href="https://roadmap.hotelmeister.io/hotel-management-software/updates/" target="_blank">Neuigkeiten</a></span>
        <!--        <span class="link&#45;&#45;support col-12"><a href="https://hotelmeisterhelp.zendesk.com/hc/de" target="_blank">Knowledge Base (ALT)</a></span>-->
        <span class="link--support col-12"><a href="https://hotelmeister.betteruptime.com/" target="_blank">Systemstatus</a></span>
      </hm-card-inner>
      <hm-card-inner title="Support-Zeiten">
        <span class="link--support col-12">Mo-Fr 09:00-12:00</span>
        <span class="link--support col-12">Mo-Do 14:00-16:00</span>
        <span class="link--support col-12">Wochenenden, Feiertage und Fenstertage (Zwickeltage) geschlossen</span>
        <span class="link--support col-12">Wir haben aktuell: <b>{{ open ? 'Geöffnet': 'Geschlossen' }}</b> <template v-if="holiday">(Heute ist ein Feiertag)</template></span>
      </hm-card-inner>
      <hm-card-inner title="Betriebsurlaube / Fenstertage (kommende 4 Wochen)">
        <template v-for="itVacation in vacations">
          <template v-if="itVacation[0] >= today && itVacation[0] <= maxDate">
            <span class="link--support col-12">
              <template v-if="itVacation[0] !== itVacation[1]">
                {{ itVacation[0] | toDate }} - {{ itVacation[1] | toDate }} <template v-if="today >= itVacation[0] && today <= itVacation[1]">(Aktiv)</template>
              </template>
              <template v-else>
                {{ itVacation[0] | toDate }} <template v-if="today >= itVacation[0] && today <= itVacation[1]">(Aktiv)</template><template v-else-if="itVacation.length === 3">({{ itVacation[2] }})</template>
              </template>
            </span>
          </template>
        </template>
      </hm-card-inner>
      <hm-card-inner title="Feiertage (kommende 4 Wochen)">
        <template v-for="itHoliday in holidays">
          <span v-if="itHoliday >= today && itHoliday <= maxDate" class="link--support col-12">
            {{ itHoliday | toDate }} <template v-if="today === itHoliday">(Aktiv)</template>
          </span>
        </template>
      </hm-card-inner>
      <hm-card-inner v-if="!open" :full-size="true">
        <span class="warning-text warning-text--full-size warning-text--no-margin col-12">Außerhalb der Öffnungszeiten nutzen Sie bitte die Support-Funktion am rechten Bildschirmrand oder schicken Sie uns eine E-Mail.</span>
      </hm-card-inner>
      <hm-card-inner v-if="open && vacation" :full-size="true">
        <span class="warning-text warning-text--full-size warning-text--no-margin col-12">Wir sind momentan telefonisch leider nicht erreichbar. Wenn möglich nutzen Sie bitte die Support-Funktion am rechten Bildschirmrand oder schicken Sie uns eine E-Mail.</span>
      </hm-card-inner>
      <hm-card-inner title="Kontaktinformationen">
        <span class="link--support col-start-1 col-4 col-2@hd text--bold">E-Mail</span><span class="link--support col-8"><a href="mailto:support@hotelmeister.com" target="_blank">support@hotelmeister.com</a></span>

        <span class="link--support col-start-1 col-4 col-2@hd text--bold">Telefon (Österreich)</span>
        <span class="link--support col-8"><a :class="{ 'blur': !open }" href="tel:+43720881990" target="_blank">+43 720 88 19 90</a><span v-if="!open"> (Geschlossen)</span></span>

        <span class="link--support col-start-1 col-4 col-2@hd text--bold">Telefon (USA)</span>
        <span class="link--support col-8"><a :class="{ 'blur': !open }" href="tel:+19294464112" target="_blank">+1 929-446-4112</a><span v-if="!open"> (Geschlossen)</span></span>
      </hm-card-inner>
    </card>
    <card title="Quick-Support Anwendung" cols="12 6@desktop">
      <hm-card-inner title="Download">
        <span class="link--support col-12"><a href="https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/C2K1J27JCZ6C/HotelmeisterSupport.exe" style="text-decoration:underline;">für Windows</a><br></span>
        <span class="link--support col-12"><a href="https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/C2K1J27JCZ6C/HotelmeisterSupport.exe" style="text-decoration:underline;">für macOS</a><br></span>
        <span class="link--support col-12"><a href="https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/C2K1J27JCZ6C/HotelmeisterSupport.exe" style="text-decoration:underline;">für Android</a><br></span>
        <span class="link--support col-12"><a href="https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/C2K1J27JCZ6C/HotelmeisterSupport.exe" style="text-decoration:underline;">für Linux (64-Bit)</a></span>
      </hm-card-inner>
      <hm-card-inner title="macOS">
        <span class="col-12">
          Wenn Sie auf die Quick-Support-Anwendung auf einem Mac (Apple) ausführen möchten und die Fehlermeldung <i>"'AnyDesk' kann nicht geöffnet werden, da es nicht aus dem App Store geladen wurde."</i> angezeigt wird, dann führen Sie bitte die nachfolgenden Schritte aus.
        </span>
        <ol class="col-12">
          <li>Systemeinstellungen > Sicherheit</li>
          <li>Registerkarte "Allgemein"</li>
          <li>Abschnitt "Apps-Download erlauben von:"</li>
          <li>Neben dem Knopf "Dennoch öffnen" sollte "Das Öffnen von 'AnyDesk' wurde blockiert, ..."</li>
          <li>Klicke auf "Dennoch öffnen"</li>
        </ol>
      </hm-card-inner>
    </card>

    <card title="Technische Informationen" cols="12 6@desktop">
      <hm-card-inner ref="supportData" full-size>
        <hm-col cols="12">
          <p style="font-family: monospace,monospace;font-size: 1.4rem;cursor: copy;padding: 1.5rem;" @click="copySupportData">
            User: {{ $root.username }}<br/>
            Hotel: {{ $root.hotel }}<br/>
            ---<br/>
            Environment: {{ $root.$jwt.decode(getToken($root.hotel)).iss }}<br/>
            SessionID: {{ $root.$jwt.decode(getToken($root.hotel)).sid }}<br/>
            TabID: {{ $root.tabId }}<br/>
            FullUsername: {{ $root.$jwt.decode(getToken($root.hotel)).sub }}<br/>
            Host: {{ $root.$jwt.decode(getToken($root.hotel)).host }}<br/>
            Tenant: {{ $root.$jwt.decode(getToken($root.hotel)).tenant }}<br/>
            LoginDateTime: {{ new Date($root.$jwt.decode(getToken($root.hotel)).auth_time * 1000) }} ({{ $root.$jwt.decode(getToken($root.hotel)).auth_time }})<br/>
          </p>
        </hm-col>
      </hm-card-inner>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HmCardInner from '../lib/layout/HmCardInner';
import TimerMixin from '../../mixins/TimerMixin';
import { getToken } from '../../lib/util/token';
import { TimelineMax, TweenMax } from 'gsap';
import HotelmeisterMixin from '../../mixins/HotelmeisterMixin';
import { isEmpty, isNil, sortBy } from 'lodash';
import VacationMixin from '../../mixins/VacationMixin';

export default {
  name: 'PageSupport',
  components: { HmCardInner },
  mixins: [TimerMixin, HotelmeisterMixin, VacationMixin],

  data() {
    return {
      open: false,
      holiday: false,
      vacation: false,
    };
  },

  computed: {
    maxDate: function () {
      const now = this.$moment().tz('Europe/Vienna');
      return now.add(4, 'weeks').format('YYYY-MM-DD');
    },
  },

  created() {
    this.recomputeOpen();
    this.setInterval(this.recomputeOpen, 5000);
  },

  methods: {
    getToken,
    recomputeOpen() {
      this.open = this.isOpen();
    },
    isOpen() {
      const now = this.$moment().tz('Europe/Vienna');

      if (now.weekday() === 5 || now.weekday() === 6) return false;

      if (now.hour() < 9) return false;
      if (now.hour() === 12) return false;
      if (now.hour() === 13) return false;
      if (now.weekday() === 4 && now.hour() >= 12) return false;
      else if (now.hour() >= 16) return false;

      this.holiday = this.holidays.includes(now.format('YYYY-MM-DD'));
      if (this.holiday === true) return false;

      this.vacation = this.vacations.map((it) => {
        const startDate = this.$moment(it[0], 'YYYY-MM-DD').startOf('day');
        const endDate = this.$moment(it[1], 'YYYY-MM-DD').endOf('day');

        if (now.isBefore(startDate)) return false;
        if (now.isAfter(endDate)) return false;

        return true;
      }).includes(true);

      if (this.vacation) return false;

      return true;
    },
    copySupportData() {
      this.$copy(this.$refs.supportData.$el.innerText);
      const el = this.$refs.supportData.$el;
      const tl = new TimelineMax({
        onComplete: () => {
          el.style.boxShadow = null;
        },
      });
      tl.add(TweenMax.fromTo(el, 0.25, { backgroundColor: '#fff' }, { backgroundColor: '#bbdcd8' }));
      tl.add(TweenMax.fromTo(el, 0.5, { backgroundColor: '#bbdcd8' }, { backgroundColor: '#fff' }));
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .link--support {
    padding: 5px 0;
    a {
      color: $blue;
      text-decoration: underline;
      cursor: pointer!important;
      pointer-events: all;
    }
  }
  .blur {
    text-shadow: 0px 0px 5px $blue!important;
    color: rgba(0,0,0,0.0)!important;
    pointer-events: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageSupport.vue